module.exports = "<div class=\"view-port main-div\">\n    <h3 class=\"module-header header-margin\">\n        <span class=\"span-margin\">Disaster Recovery</span>\n    </h3>\n    <iframe class=\"embedded-content-view iframe-style\" name=\"disaster-recovery-embed\" [src]=\"iframeUrl\"\n        frameborder=\"0\">\n    </iframe>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/disaster-recovery/disaster-recovery-embed.html
// module id = mtHd
// module chunks = 0